export default __webpack_public_path__ + "static/media/search-confetti.a4fddebb.svg";